import React, { useEffect, useState } from 'react';
import api from '../services/api';
import "../styles/dataTable.css";
import { toast } from 'react-toastify';
import CustomSelect from '../components/CustomSelect';

const ManageUserPermissions = () => {
  const [users, setUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState('');

  const [modules, setModules] = useState([]);
  const [checkedPermissions, setCheckedPermissions] = useState([]);
  const [hasExistingAccess, setHasExistingAccess] = useState(false);
  const [openModule, setOpenModule] = useState(null);


  // ---------------- Fetch Users ----------------
  const fetchUsers = async () => {
    try {
      const response = await api.get(`/adminusers/get-all`);
      setUsers(response.data.data);
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // ---------------- Fetch Modules + User Access ----------------
  useEffect(() => {
    if (!selectedUserId) return;

    const fetchPermissionsData = async () => {
      try {
        // All modules
        const modulesRes = await api.get('https://services.bashaarat.com/modules/list');
        console.log("modules", modulesRes.data.data)
        setModules(modulesRes.data.data);

        // User access
        const accessRes = await api.get(`https://services.bashaarat.com/access/get/${selectedUserId}`);
        const accessData = accessRes.data.data;

        setHasExistingAccess(accessData.length > 0);

        // Preload checked
        setCheckedPermissions(
          accessData.map(a => ({
            module_id: a.module_id,
            sub_module_id: a.sub_module_id || null
          }))
        );

      } catch (err) {
        console.error("Error loading permissions:", err);
      }
    };

    fetchPermissionsData();
  }, [selectedUserId]);

  // ---------------- Helpers ----------------
  const isChecked = (module_id, sub_module_id) => {
    return checkedPermissions.some(p =>
      p.module_id === module_id &&
      (p.sub_module_id || null) === (sub_module_id || null)
    );
  };

  const togglePermission = (module_id, sub_module_id) => {
    setCheckedPermissions((prev) => {
      let updated = [...prev];

      const exists = updated.some(
        (p) =>
          p.module_id === module_id &&
          (p.sub_module_id || null) === (sub_module_id || null)
      );

      // ---------------- IF SUBMODULE CLICKED ----------------
      if (sub_module_id) {
        if (exists) {
          // remove submodule
          updated = updated.filter(
            (p) =>
              !(
                p.module_id === module_id &&
                p.sub_module_id === sub_module_id
              )
          );

          // if no submodules left → remove parent
          const stillHasSub = updated.some(
            (p) => p.module_id === module_id && p.sub_module_id !== null
          );

          if (!stillHasSub) {
            updated = updated.filter(
              (p) => !(p.module_id === module_id && p.sub_module_id === null)
            );
          }
        } else {
          // add submodule
          updated.push({ module_id, sub_module_id });

          // ensure parent is added
          const parentExists = updated.some(
            (p) => p.module_id === module_id && p.sub_module_id === null
          );

          if (!parentExists) {
            updated.push({ module_id, sub_module_id: null });
          }
        }
      }

      // ---------------- IF PARENT CLICKED ----------------
      else {
        if (exists) {
          // ❌ Uncheck parent → remove all children too
          updated = updated.filter((p) => p.module_id !== module_id);
        } else {
          // ✅ Check parent → add parent
          updated.push({ module_id, sub_module_id: null });

          // ✅ ALSO ADD ALL ITS CHILDREN
          const children = modules.filter(
            (m) => m.module_id === module_id && m.sub_module_id
          );

          children.forEach((child) => {
            updated.push({
              module_id: child.module_id,
              sub_module_id: child.sub_module_id,
            });
          });
        }
      }

      return updated;
    });
  };



  // ---------------- Group Modules ----------------
  const groupedModules = modules.reduce((acc, curr) => {
    const key = curr.module_id;

    if (!acc[key]) {
      acc[key] = {
        module_name: curr.module_name,
        module_id: curr.module_id,
        children: []
      };
    }

    if (curr.sub_module_id) {
      acc[key].children.push(curr);
    }

    return acc;
  }, {});

  // ---------------- Save Permissions ----------------
  const handleSavePermissions = async () => {
    try {
      const formData = new FormData();
      formData.append('admin_id', selectedUserId);

      checkedPermissions.forEach((perm, index) => {
        formData.append(`access[${index}][module_id]`, perm.module_id);
        formData.append(
          `access[${index}][sub_module_id]`,
          perm.sub_module_id || ''
        );
      });

      const url = hasExistingAccess
        ? 'https://services.bashaarat.com/access/edit'
        : 'https://services.bashaarat.com/access/insert';

      await api.post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      toast.success('Permissions saved successfully!');
    } catch (err) {
      toast.error('Error saving permissions', err);
    }
  };

  const CustomCheckbox = ({ checked, onChange }) => (
  <label className="custom-checkbox" style={{ display: "inline-flex", alignItems: "center" }}>
    <input type="checkbox" checked={checked} onChange={onChange} />
    <span />
  </label>
);


  // ---------------- UI ----------------
  return (
    <div style={{ padding: "20px" }}>
      <div className="table-header">
        <h2 style={{ fontWeight: 700 }}>User Permissions</h2>

        {/* Select User */}
        <div >
          
          <CustomSelect 
            options={users}
            value={selectedUserId}
            onChange={(val) => setSelectedUserId(val)}
            labelKey="name"
            valueKey="id"
            placeholder="Select User"
          />
        </div>

      </div>


      {/* Permissions */}
      {selectedUserId && (
  <div style={{ marginTop: 20 }}>
    <table width="100%" cellpadding="26" class="table-no-outer-border">
      <thead>
        <tr style={{ background: "#f5f5f5" }}>
          <th >Module</th>
          <th >Access</th>
          <th >Add (Create)</th>
          <th >Edit</th>
        </tr>
      </thead>

      <tbody>
        {Object.values(groupedModules).map((mod) => {
          const hasChildren = mod.children.length > 0;

          return (
            <React.Fragment key={mod.module_id}>
              {/* Parent Module Row */}
              <tr >
                <td style={td}>
                  {hasChildren && (
                    <button
                      onClick={() =>
                        setOpenModule(
                          openModule === mod.module_id
                            ? null
                            : mod.module_id
                        )
                      }
                      style={accordionBtn}
                    >
                      {openModule === mod.module_id ? "▼" : "▶"}
                    </button>
                  )}

                  <strong>{mod.module_name}</strong>
                </td>

                <td style={centerTd}>
                  {/* <input
                    type="checkbox"
                    checked={isChecked(mod.module_id, null, "access")}
                    onChange={() =>
                      togglePermission(mod.module_id, null, "access")
                    }
                  /> */}
                  <CustomCheckbox
                    checked={isChecked(mod.module_id, null, "access")}
                    onChange={() =>
                      togglePermission(mod.module_id, null, "access")
                    }
                  />
                </td>

                <td style={centerTd}>
                  {/* <input
                    type="checkbox"
                    checked={isChecked(mod.module_id, null, "add")}
                    onChange={() =>
                      togglePermission(mod.module_id, null, "add")
                    }
                  /> */}
                  <CustomCheckbox
                    checked={isChecked(mod.module_id, null, "add")}
                    onChange={() =>
                      togglePermission(mod.module_id, null, "add")
                    }
                  />
                </td>

                <td style={centerTd}>
                  {/* <input
                    type="checkbox"
                    checked={isChecked(mod.module_id, null, "edit")}
                    onChange={() =>
                      togglePermission(mod.module_id, null, "edit")
                    }
                  /> */}
                  <CustomCheckbox
                    checked={isChecked(mod.module_id, null, "edit")}
                    onChange={() =>
                      togglePermission(mod.module_id, null, "edit")
                    }
                  />
                </td>
              </tr>

              {/* Sub Modules Accordion */}
              {hasChildren && openModule === mod.module_id && (
                <tr>
                  <td colSpan={4} style={{ padding: 0 }}>
                    <table style={{ width: "100%" }}>
                      <tbody>
                        {mod.children.map((sub) => (
                          <tr key={sub.sub_module_id} style={{ background: "#fafafa" }}>
                            <td style={{ ...td, paddingLeft: 40 }}>
                              {sub.sub_module_name}
                            </td>

                            <td style={centerTd}>
                              {/* <input
                                type="checkbox"
                                checked={isChecked(
                                  sub.module_id,
                                  sub.sub_module_id,
                                  "access"
                                )}
                                onChange={() =>
                                  togglePermission(
                                    sub.module_id,
                                    sub.sub_module_id,
                                    "access"
                                  )
                                }
                              /> */}
                              <CustomCheckbox
                                checked={isChecked(
                                  sub.module_id,
                                  sub.sub_module_id,
                                  "access"
                                )}
                                onChange={() =>
                                  togglePermission(
                                    sub.module_id,
                                    sub.sub_module_id,
                                    "access"
                                  )
                                }
                              />
                            </td>

                            <td style={centerTd}>
                              
                              <CustomCheckbox
                                checked={isChecked(
                                  sub.module_id,
                                  sub.sub_module_id,
                                  "add"
                                )}
                                onChange={() =>
                                  togglePermission(
                                    sub.module_id,
                                    sub.sub_module_id,
                                    "add"
                                  )
                                }
                              />
                            </td>

                            <td style={centerTd}>
                              
                              <CustomCheckbox
                                checked={isChecked(
                                  sub.module_id,
                                  sub.sub_module_id,
                                  "edit"
                                )}
                                onChange={() =>
                                  togglePermission(
                                    sub.module_id,
                                    sub.sub_module_id,
                                    "edit"
                                  )
                                }
                              />
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </td>
                </tr>
              )}
            </React.Fragment>
          );
        })}
      </tbody>
    </table>

        <div >
          <button style={{ marginTop: 20 }} className='save-btn' onClick={handleSavePermissions}>
            Save Permissions
          </button>
        </div>
  </div>
)}

    </div>
  );
};

export default ManageUserPermissions;




const th = {
  padding: 10,
  border: "2px solid #F2F2F2",
  textAlign: "left",
  fontWeight: "500",
};

const td = {
  padding: 10,
  border: "2px solid #F2F2F2",
  width: "25%",
  fontWeight: 500,
};

const centerTd = {
  ...td,
  textAlign: "center",
};

const accordionBtn = {
  marginRight: 8,
  border: "none",
  background: "transparent",
  cursor: "pointer",
  fontSize: 14,
};
